<template>
  <div class="modal-content">
    <a-form :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item
        v-for="item in formOption"
        :key="item.value"
        :label="item.label"
      >
        <!-- 输入 -->
        <a-input
          v-if="item.type === 'input'"
          v-model="form[item.value]"
          :placeholder="'请输入' + item.label"
        ></a-input>
        <!-- 搜索 -->
        <a-select
          v-if="item.type === 'select'"
          v-model="form[item.value]"
          @change="change()"
          :placeholder="'请选择' + item.label"
        >
          <a-select-option
            v-for="opt in item.options"
            :key="opt.value"
            :value="opt.value"
            >{{ opt.label }}</a-select-option
          >
        </a-select>
        <!-- 远程搜索 -->
        <a-select
          v-if="item.type === 'remoteSearch'"
          show-search
          v-model="form[item.value]"
          :placeholder="'请输入查询' + item.label"
          :default-active-first-option="false"
          :show-arrow="true"
          :filter-option="false"
          :not-found-content="null"
          @search="handleSearch($event, item.method, item.value)"
          @change="handleChange"
        >
          <a-select-option
            v-for="opt in item.options"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <div style="margin-top: 20px; text-align: right">
      <a-button @click="cancel()">返回</a-button>
      <a-button @click="submit()" type="primary" style="margin-left: 16px"
        >确认</a-button
      >
    </div>
  </div>
</template>
<script>
import { SelectOptions } from "@/config/SelectOptions.js";
import { AddWorker, UpdateWorker } from "@/api/worker";
import { GetCompanies } from "@/api/device";

const formOption = [
  {
    label: "员工ID",
    value: "w_id",
    type: "input",
  },
  {
    label: "姓名",
    value: "w_name",
    type: "input",
  },
  {
    label: "性别",
    value: "w_sex",
    type: "select",
    options: SelectOptions.WorkerSex,
  },
  {
    label: "岗位",
    value: "w_post",
    type: "select",
    options: SelectOptions.WorkPost,
  },
  {
    label: "工种",
    value: "w_type",
    type: "select",
    options: SelectOptions.WorkType,
  },
  {
    label: "分公司名称",
    value: "bc_id",
    type: "remoteSearch",
    options: [],
    method: "GetCompanies",
  },
  {
    label: "联系方式",
    value: "w_contact",
    type: "input",
  },
  {
    label: "所属项目经理",
    value: "w_jl",
    type: "input",
  },
];
export default {
  name: "WorkerAdd",
  props: {
    formType: {
      type: String,
      default: "add",
    },
    record: {
      type: Object,
    },
  },
  data() {
    return {
      formOption: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {},
    };
  },
  async created() {
    this.formOption = formOption;
    this.fetchCompany();
    if (this.formType === "edit") {
      // console.log(this.record);--wyk
      this.form = JSON.parse(JSON.stringify(this.record));
    }
  },
  methods: {
    fetchCompany() {
      let data = [];
      GetCompanies().then((res) => {
        res.data.forEach((el) => {
          data.push({
            label: el.bc_name,
            value: el.bc_id,
          });
        });
        let index = null;
        this.formOption.forEach((el, i) => {
          if (el.value === "bc_id") {
            index = i;
          }
        });
        this.formOption[index].options = data;
      });
    },
    handleChange() {},
    handleSearch(val, method, key) {},
    cancel() {
      this.$emit("emitEdit");
    },
    submit() {
      let req = null;
      if (this.formType === "add") {
        const orderParam = this.$order(this.form, addVerify);
        const params = {
          ...orderParam,
          verify: this.$verify(orderParam, addVerify),
        };
        req = AddWorker(params);
      } else {
        const orderParam = this.$order(this.form, editVerify);
        const params = {
          ...orderParam,
          verify: this.$verify(orderParam, editVerify),
        };
        req = UpdateWorker(params);
      }
      this.$emit("emitEdit");
      // req.then(res => {
      //   this.$message.success(res.data);
      //   this.$emit('emitEdit')
      // })
    },
  },
};
</script>
